<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
       <div class="d-flex justify-content-between">
              <div class="section-title">
                {{ "Ticket Report " }}
              </div>       
              <div class="d-flex align-items-center">         
                <div class="d-flex align-item-center">
                      <input value="1" type="radio" v-model="lang_id">
                      <span class="ml-1">English</span>
                    </div>
                    <div class="d-flex align-item-center ml-2">
                    <input value="2" type="radio" v-model="lang_id">
      
                    <span class="ml-1">العربية</span>
                  </div>
              </div>
            </div>
      <div class="mt-3 mb-2">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
                     <div class="dropdown-curve-container">
                       <label :class="dropDown.selectedCinema ? 'shift-up' : 'font-weight-bold'"
                         >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                       >
                       <multiselect
                                      :disabled="isRoleID"
                                      :options="dropDown.cinemas"
                                      v-model="dropDown.selectedCinema"
                                      :searchable="true"
                                      label="cine_name"
                                      track-by="cine_id"
                                      placeholder="Movie"
                                      @input="onSelectCinema($event)"
                                      :allowEmpty="false"
                                      :showLabels="false"
                                    ></multiselect>
                     </div>
                   </div>

          <!-- select transaction and show date filter -->
          <!-- <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedDateType && selectedDateType.hasOwnProperty('value')
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("Select Date Type") }}</label
              >
              <multiselect
                :options="dateTypes"
                v-model="selectedDateType"
                placeholder=""
                label="name"
                :multiple="false"
                :close-on-select="true"
                track-by="value"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div> -->
          <!-- select transaction and show date filter -->

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
              <Datepicker
                :monday-first="true"
                type="date"
                ref="programaticOpen"
                v-model="fromDate"
                v-validate="'required'"
                @selected="onChangeDate($event, 'from')"
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">
                <!-- {{ $t("show") }} -->
                {{ $t("fromdate") }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="toDate"
                v-validate="'required'"
              >
              </Datepicker>
              <label :class="toDate ? 'active' : ''">
                <!-- {{ $t("show") }}  -->
                {{ $t("todate") }}</label
              >
            </div>
          </div>
        </div>

          <!-- payment filter -->
          <div class="col-12 col-md-6 col-lg-3 col-xl-3  mb-3">
          <div class="dropdown-curve-container">
            <label
                :class="
                  selectedPaymentSource && selectedPaymentSource.length > 0
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                > {{ selectedPaymentSource && selectedPaymentSource.length > 0 ? $t("Payment Mode") : $t("All Payment Mode") }}</label
              >
            <multiselect
             
              :options="paymentList"
              v-model="selectedPaymentSource"
              placeholder=""
              label="pm_payment_mode"
              :multiple="true"
              :close-on-select="false"
              track-by="pm_id"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>
        <!-- payment filter -->

        <!-- movie filter -->
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
        <div class="dropdown-curve-container">
          <label :class="selectedMovieName && selectedMovieName.length > 0 ? 'shift-up' : 'font-weight-bold'">
              {{ selectedMovieName && selectedMovieName.length > 0 ? $t("Movies") : $t("All Movies") }}
            </label>
          <multiselect v-model="selectedMovieName" :options="allMovieNames" track-by="movie_name"
            label="movie_name" :disabled="isRoleID" :searchable="true" placeholder="Movies" :multiple="true">
          </multiselect>
        </div>
      </div>
        <!-- movie filter -->

        <!-- Distributor Filter -->
        <div class="col-lg-6 col-xl-3 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedDistributor.length > 0 ? 'shift-up' : 'font-weight-bold'">
                          {{ selectedDistributor && selectedDistributor.length > 0 ? $t("Distributors") : $t("All Distributors") }}
                         </label>

              <multiselect v-model="selectedDistributor" @input="onSelectHandler($event, 'distributor')"
                @remove="onRemoveHandler($event, 'distributor')" placeholder=""
                :options="getDistributorReportDropdownList" label="d_company_name" track-by="d_id" :multiple="true"
                name="d_id" id="d_id" select-label="Select" deselect-label="Remove">
              </multiselect>
            </div>
          </div>
        </div>
        <!-- Distributor Filter -->  

           <!-- Screen Filter -->
           <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                   <div class="dropdown-curve-container">
                    <label :class="selectedScreenName && selectedScreenName.length > 0 ? 'shift-up' : 'font-weight-bold'">
              {{ selectedScreenName && selectedScreenName.length > 0 ? $t("Screens") : $t("All Screens") }}
              </label>
                     <multiselect v-model="selectedScreenName" :options="allScreenNames" track-by="screen_name"
                       label="screen_name" :disabled="isRoleID" :searchable="true" placeholder="Screens" :multiple="true">
                     </multiselect>
                   </div>
                 </div> 
        <!-- Screen Filter -->

             <!-- User Filter -->
                     <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
                               <div class="dropdown-curve-container">
                                <label
                           :class="
                              selectedUsers && selectedUsers.length > 0
                               ? 'shift-up'
                               : 'font-weight-bold'
                           "
                           > {{ selectedUsers && selectedUsers.length > 0 ? $t("User") : $t("All Users") }}</label
                         >
                                 <multiselect
                                   :options="Users"
                                   v-model="selectedUsers"
                                   placeholder=""
                                   label="username"
                                   :multiple="true"
                                   :close-on-select="true"
                                   track-by="user_id"
                                 ></multiselect>
                               </div>
                             </div>
                <!-- User Filter -->

           <!-- Show Time -->
           <div class="position-relative col-lg-3 col-xl-2 mb-2">
                                 <vue-timepicker manual-input
                                  v-model="start_time"
                                   id="starttime"
                                   name="starttime"
                                   :placeholder="$tc('starttime')"
                                    format="HH:mm"
                                    class="time_picker"
                                    input-width="100%"
                                    auto-scroll
                                   lazy ></vue-timepicker>
                               </div>
                    
                       <div class="position-relative col-lg-3 col-xl-2 mb-2">
               <vue-timepicker
                 manual-input
                 v-model="end_time"
                 id="endtime"
                 name="endtime"
                 :placeholder="$tc('endtime')"
                 format="HH:mm"
                 class="time_picker"
                 input-width="100%"
                 auto-scroll
                 lazy
               />
             </div>
        <!-- Show Time -->

      
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getShowDetailsData('N', 'N')"
            >
              {{ $t("fetch") }}
            </button>
          </div>

          <div
            v-if="ticketDataPaymentWise.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <a
              target="_blank"
              @click="getShowDetailsData('Y', 'N')"
              title="Download as Excel"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getShowDetailsData('N', 'Y')"
              title="Download as PDF"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <!-- Booking Source Wise Collection -->
      <div>
        <div class="section-title">Booking Channels</div>
        <div
          v-if="groupedDataForTicket.length > 0"
          style="overflow-x: scroll; width: auto !important"
        >
          <table :class="[lang_id == 2 ? 'swc-report-table reverse-order' : 'swc-report-table order', 'table-bordered']">
            <thead class="bg-lightgrey font-weight-bold">
              <tr>
                <th colspan="2"></th>
                <th
                  v-for="payment in groupedDataForTicket"
                  :key="payment.bs_id"
                >
                  {{ payment.bs_source }}
                </th>
                <th>{{ trans("total", lang_id) }}</th>
              </tr>
            </thead>
            <tbody>
<tr>
  <td colspan="2" class="text-left">{{ trans("totalSoldTicket", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in groupedDataForTicket"
    :key="'count-' + group.bs_id"
  >
    {{ group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0 }}
  </td>
  <td class="text-right">
{{
  groupedDataForTicket.reduce((sum, group) => {
    return sum + (group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0)
  }, 0)
}}
</td>
</tr>

<tr class="font-weight-bold bg-light">
  <td colspan="2" class="text-left">{{ trans("TotalSoldTicketsRevenue", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in groupedDataForTicket"
    :key="'total-' + group.bs_id"
  >
    {{ group.payment_data.length > 0 ? currFormat(group.payment_data[0].total) : currFormat(0) }}
  </td>
  <td class="text-right">
{{
  currFormat(
    groupedDataForTicket.reduce((sum, group) => {
      return sum + (group.payment_data.length > 0 ? group.payment_data[0].total : 0)
    }, 0)
  )
}}
</td>
</tr>


<!-- Total Sold 3D Glasses -->
<tr>
  <td colspan="2" class="text-left">{{ trans("TotalSold3DGlasses", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in groupedDataFor3DGlass"
    :key="'count-' + group.bs_id"
  >
    {{
      group.payment_data.reduce((sum, item) => sum + item.total_counts, 0)
    }}
  </td>
  <td class="text-right">
    {{
      groupedDataFor3DGlass.reduce((sum, group) => {
        return sum + group.payment_data.reduce((gSum, item) => gSum + item.total_counts, 0)
      }, 0)
    }}
  </td>
</tr>

<tr class="font-weight-bold bg-light">
  <td colspan="2" class="text-left">{{ trans("TotalSold3DGlassesRevenue", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in groupedDataFor3DGlass"
    :key="'total-' + group.bs_id"
  >
    {{
      currFormat(
        group.payment_data.reduce((sum, item) => sum + item.total, 0)
      )
    }}
  </td>
  <td class="text-right">
    {{
      currFormat(
        groupedDataFor3DGlass.reduce((sum, group) => {
          return sum + group.payment_data.reduce((gSum, item) => gSum + item.total, 0)
        }, 0)
      )
    }}
  </td>
</tr>

<!-- Total Sold 3D Glasses -->

<!-- gap between  -->
<tr style="border: none; " 
>
<td colspan="2" style="border: none;"></td>
  <td style="border: none;" 
  v-for="payment in groupedDataForTicket"
                  :key="payment.bs_id"
  >
</td>
  <td style="border: none;"></td>
</tr>
<!-- gap between  -->
<!-- Total Purged Tickets -->
<tr>
  <td colspan="2" class="text-left">{{ trans("TotalPurgedTickets", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in groupedDataForPurgedTicket"
    :key="'count-' + group.bs_id"
  >
    {{ group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0 }}
  </td>
  <td class="text-right">
{{
  groupedDataForPurgedTicket.reduce((sum, group) => {
    return sum + (group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0)
  }, 0)
}}
</td>
</tr>


<tr class="font-weight-bold bg-light">
  <td colspan="2" class="text-left">{{ trans("TotalPurgedTicketsRevenue", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in groupedDataForPurgedTicket"
    :key="'total-' + group.bs_id"
  >
    {{ group.payment_data.length > 0 ? currFormat(group.payment_data[0].total) : currFormat(0) }}
  </td>
  <td class="text-right">
{{
  currFormat(
    groupedDataForPurgedTicket.reduce((sum, group) => {
      return sum + (group.payment_data.length > 0 ? group.payment_data[0].total : 0)
    }, 0)
  )
}}
</td>
</tr>
<!-- Total Purged Tickets -->

<!-- Total Purged 3D Glasses -->
<tr>
  <td colspan="2" class="text-left">{{ trans("TotalPurged3DGlasses", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in groupedDataForPurged3DGlass"
    :key="'count-' + group.bs_id"
  >
    {{ group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0 }}
  </td>
  <td class="text-right">
{{
  groupedDataForPurged3DGlass.reduce((sum, group) => {
    return sum + (group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0)
  }, 0)
}}
</td>
</tr>

<tr class="font-weight-bold bg-light">
  <td colspan="2" class="text-left">{{ trans("TotalPurged3DGlassesRevenue", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in groupedDataForPurged3DGlass"
    :key="'total-' + group.bs_id"
  >
    {{ group.payment_data.length > 0 ? currFormat(group.payment_data[0].total) : currFormat(0) }}
  </td>
  <td class="text-right">
{{
  currFormat(
    groupedDataForPurged3DGlass.reduce((sum, group) => {
      return sum + (group.payment_data.length > 0 ? group.payment_data[0].total : 0)
    }, 0)
  )
}}
</td>
</tr>
<!-- Total Purged 3D Glasses -->
</tbody>
          </table>
        </div>
        <div
          v-if="ticketDataPaymentWise.length == 0"
          style="overflow-x: scroll; width: auto !important"
        >
          <table class="swc-report-table" border="1">
           
            <tbody>
              <tr>
                <td colspan="4">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- Booking Source Wise Collection -->

    <!--------------------------------------- PAYMENT METHOD WISE DATA ---------------------------------->
      <div>
        <div class="section-title my-2">Payment Methods</div>
        <div
          v-if="ticketDataPaymentWise.length > 0"
          style="overflow-x: scroll; width: auto !important"
        >     
        <table :class="[lang_id == 2 ? 'swc-report-table reverse-order' : 'swc-report-table order', 'table-bordered']">
            <thead class="bg-lightgrey font-weight-bold">
              <tr>
                <th colspan="2"></th>
                <th
                  v-for="payment in ticketDataPaymentWise"
                  :key="payment.pm_id"
                >
                  {{ payment.payment_mode }}
                </th>
                <th>{{ trans("total", lang_id) }}</th>
                <th>Invitation</th>
              </tr>
            </thead>
            <tbody>
             
<tr>
  <td colspan="2" class="text-left">{{ trans("TotalSoldTickets", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in ticketDataPaymentWise"
    :key="'count-' + group.pm_id"
  >
    {{ group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0 }}
  </td>
  <td class="text-right">
{{
  ticketDataPaymentWise.reduce((sum, group) => {
    return sum + (group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0)
  }, 0)
}}
</td>
<td class="text-right">
      {{
        FreeTicketQueryData.length > 0 ? FreeTicketQueryData[0].total_counts : 0 
      }}
    </td>
</tr>

<tr class="font-weight-bold bg-light">
  <td colspan="2" class="text-left">{{ trans("TotalSoldTicketsRevenue", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in ticketDataPaymentWise"
    :key="'total-' + group.pm_id"
  >
    {{ group.payment_data.length > 0 ? currFormat(group.payment_data[0].total) : currFormat(0) }}
  </td>
  <td class="text-right">
{{
  currFormat(
    ticketDataPaymentWise.reduce((sum, group) => {
      return sum + (group.payment_data.length > 0 ? group.payment_data[0].total : 0)
    }, 0)
  )
}}
</td>
<td class="text-right">
      {{
        currFormat(FreeTicketQueryData.length > 0 ? FreeTicketQueryData[0].total : 0)
      }}
    </td>
</tr>

<tr>
  <td colspan="2" class="text-left">{{ trans("TotalSold3DGlasses", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in get3DAmountDataAsPerPaymentModes"
    :key="'count-' + group.pm_id"
  >
    {{ group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0 }}
  </td>
  <td class="text-right">
{{
  get3DAmountDataAsPerPaymentModes.reduce((sum, group) => {
    return sum + (group.payment_data.length > 0 ? group.payment_data[0].total_counts : 0)
  }, 0)
}}
</td>
<td class="text-right">
  {{ 
   glass3DQueryForFreeData[0].total_counts || 0
  }}    
   </td>
</tr>

<tr class="font-weight-bold bg-light">
  <td colspan="2" class="text-left">{{ trans("TotalSold3DGlassesRevenue", lang_id) }}</td>
  <td
    class="text-right"
    v-for="group in get3DAmountDataAsPerPaymentModes"
    :key="'total-' + group.pm_id"
  >
    {{ group.payment_data.length > 0 ? currFormat(group.payment_data[0].total) : currFormat(0) }}
  </td>
  <td class="text-right">
{{
  currFormat(
    get3DAmountDataAsPerPaymentModes.reduce((sum, group) => {
      return sum + (group.payment_data.length > 0 ? group.payment_data[0].total : 0)
    }, 0)
  )
}}
</td>
<td class="text-right">
  {{
        currFormat(glass3DQueryForFreeData.length > 0 ? glass3DQueryForFreeData[0].total : 0) 
  }}
</td>
</tr>


<tr class="font-weight-bold bg-light">
<td colspan="2" class="text-left">{{ trans("TotalTicketsGlassesRevenue", lang_id) }}</td>
<td
  class="text-right"
  v-for="(ticketGroup, index) in ticketDataPaymentWise"
  :key="'combined-total-' + ticketGroup.pm_id"
>
  {{
    currFormat(
      (ticketGroup.payment_data.length > 0 ? ticketGroup.payment_data[0].total : 0) +
      (get3DAmountDataAsPerPaymentModes[index] && get3DAmountDataAsPerPaymentModes[index].payment_data.length > 0
        ? get3DAmountDataAsPerPaymentModes[index].payment_data[0].total
        : 0)
    )
  }}
</td>
<td class="text-right">
  {{
    currFormat(
      ticketDataPaymentWise.reduce((sum, group, index) => {
        const ticketTotal = group.payment_data.length > 0 ? group.payment_data[0].total : 0;
        const glassTotal =
        get3DAmountDataAsPerPaymentModes[index] && get3DAmountDataAsPerPaymentModes[index].payment_data.length > 0
            ? get3DAmountDataAsPerPaymentModes[index].payment_data[0].total
            : 0;
        return sum + ticketTotal + glassTotal;
      }, 0)
    )
  }}
</td>
<td class="text-right">
  {{
     currFormat(
  (FreeTicketQueryData[0].total_before_offer || 0) +
  (glass3DQueryForFreeData[0].total || 0)
)
    }}
    </td>
</tr>
</tbody>
          </table>
        </div>
        <div
          v-if="ticketDataPaymentWise.length == 0"
          style="overflow-x: scroll; width: auto !important"
        >
          <table class="swc-report-table" border="1">
            <tbody>
              <tr>
                <td colspan="4">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import NewReportService from "../../../services/NewReportService";
  import FnBReportService from "@/services/FnBReportsService";
  import PosFnbService from "@/services/PosFnbService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import xlsx from "json-as-xlsx";
  import { mapState, mapGetters, mapActions } from "vuex";
   import VueTimepicker from "vue2-timepicker";
    import "vue2-timepicker/dist/VueTimepicker.css";
    import { authenticationService } from "@/services/AuthenticationService";
     import ReportService from "@/services/ReportsService";

  export default {
    components: {
      NoRecords,
      VueTimepicker
    },
    computed: {
        ...mapGetters([
            "getDistributorReportDropdownList"
          ]),
        distributorIds() {
            let text = ``;
            if (this.selectedDistributor.length > 0) {
              text = this.selectedDistributor.map(x => x.d_id).join(",");
            }
      
            return text;
          },
    },
    data() {
      return {
        lang_id:"1",
        selectedUsers:[],
        Users:[],
         selectedDistributor:[],
         paymentList:[],
        selectedPaymentSource:[],
         selectedMovieName: [],
        allMovieNames: [],
          start_time:"",
          end_time:"",
        selectedDateType: {
                  name: "As Per Transaction Date",
                  value: "transaction_date",
                },
                dateTypes: [
                  {
                    name: "As Per Transaction Date",
                    value: "transaction_date",
                  },
                  {
                    name: "As Per Show Date",
                    value: "show_date",
                  },
                ],
        showNegative: "Y",
        showNegativeWatchers: "Y",
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        selectedCinema: [],
        ticketDataPaymentWise: [],
        get3DAmountDataAsPerPaymentModes: [],
        fromDate: null,
        toDate: null,
        disabledAfter: new Date(),
        grandTotal: {},
        disabledDates: {
          from: "",
        },
        groupedDataForTicket: [],
        groupedDataFor3DGlass: [],
        groupedDataForPurgedTicket:[],
        groupedDataForPurged3DGlass: [],
        FreeTicketQueryData: [],
        selectedScreenName:[],
        allScreenNames:[],
        glass3DQueryForFreeData: [],

      };
    },
    beforeMount() {
       this.fetchReportDistributorsList();
      this.getPaymentTypes();
        this.getCinemaList();
         this.getUsers();
      // this.fromDate = new Date();
    },
    watch: {
      fromDate() {
        this.getShowDetailsData("N", "N", "filter");
        this.getShowDetailsData("N", "N", "filter2");
        
      },
      toDate() {
        this.getShowDetailsData("N", "N", "filter");  
        this.getShowDetailsData("N", "N", "filter2");
        
      },
    },

    mounted() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      // this.getCinemaList(cinemaId);
    },

    methods: {
      onSelectHandler(event,type){
              if (type =="distributor") {
              this.d_id = event.d_id;
              // this.selectedMovie = [];
              // this.MovieList = [];
               this.fetchDistributorMovies();
              // this.selectedDistributor = event;
            }
            },
             onRemoveHandler(event,type){
                    
                },
       async getUsers(index) {
              try {
                const response = await MasterService.GetActiveList({
                  tableName: "users",
                  is_active: "Y",
                });
                const { data } = response;
                if (data.status && data.Records.length > 0) {
                  this.Users = data.Records.filter(user=>user.role_id==4);
                 // console.log("Users",this.Users)
                } else {
                  console.log("show error:", data.message);
                }
              } catch (error) {
                this._CatchError(error);
              }
            },
      onChangeDate(e, type) {
    if(type == 'from'){
      this.toDate = new Date(e);
      this.$forceUpdate();
    }
  },
        fetchDistributorMovies() {
            if (!this.dropDown.selectedCinemaId) {
              this.$toasted.show("Please Select Cinema");
              this.selectedDistributor = [];
              this.$forceUpdate();
            } else {
              this.MovieList = [];

              let payload = {
                fromDate: this.fromDate,
                toDate: this.toDate,
                cinema_id: this.dropDown.selectedCinemaId,
                  cinema_name: this.dropDown.selectedCinemaName,
                  cinema_address: this.dropDown.selectedCinemaAddres,
                d_id: this.distributorIds,
                d_company_name: this.selectedDistributor
                  .map(x => x.d_company_name)
                  .join(","),
                country_id: authenticationService.get("BRGLOPCO"),
                filter_with_key: "ss_actual_start_date"
              };
              ReportService.GetDistributorMovieFormat(payload)
                .then(response => {
                  const { data } = response;
                  if (data && data.status && data.Records) {
                    this.MovieList = data.Records;
                  } else
                    this.$toasted.show(data.message || "Opps! Something went wrong");
                })
                .catch(error => {
                  this.$toasted.show(
                    "Catch Error on ReportStore fetchDistributorMovies",
                    error
                  );
                });
            }
          },
          ...mapActions([
            "fetchReportDistributorsList",
          ]),
        getPaymentTypes() {
            let body = {
              tableName: "ms_payment_modes",
              pm_is_active: "Y"
            };
            MasterService.GetActiveList(body).then(response => {
              const { data } = response;
              if (data && data.status) {
                if (data.Records.length > 0) {
                  this.paymentList = data.Records;
                 
                }
              } else this.$toasted.show(data.message || "Opps! Something went wrong");
            });
          },
      getCinemaList: function() {
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
       onSelectCinema: function (event) {
             this.dropDown.selectedCinema = event;
             this.dropDown.selectedCinemaName = event.cine_name;
             this.dropDown.selectedCinemaId = event.cine_id;
             this.dropDown.selectedCinemaAddres = event.cine_address;
             this.$store.dispatch("selectDropdownCinema", event);
           },
      async getShowDetailsData(isExcel = "N", isPdf = "N", type = "") {

        if (!this.dropDown.selectedCinemaId) {
                     return this.$toasted.show("Select Cinema");
                  }
        if (!this.selectedDateType) {
                  return this.$toasted.show("Select Date Type");
                }
                if (!this.fromDate) {
                  return this.$toasted.show("Select From Date");
                }
                
        let loader = this.$loading.show();
        try {
          let payload = {
            cinema_id: this.dropDown.selectedCinemaId,
            cinema_name: this.dropDown.selectedCinemaName || "",
            cinema_address: this.dropDown.selectedCinema.cine_address || "",
            fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
            toDate: moment(this.toDate).format("YYYY-MM-DD"),
            date_type:this.selectedDateType.value,
            start_time:this.start_time,
            end_time:this.end_time,
            payment_mode_id: this.selectedPaymentSource.map(x => x.pm_id).join(","),
            payment_mode_name: this.selectedPaymentSource.map(x => x.pm_payment_mode).join(","),
            d_id:this.distributorIds,
            d_company_name: this.selectedDistributor.map(x => x.d_company_name).join(","),
            user_id : this.selectedUsers.map(x => x.user_id),
            username : this.selectedUsers.map(x => x.username),
            lang_id: this.lang_id,
            isPdf,
            isExcel,
          };
           if (type === "filter") {
              payload["type"] = "filter";
            } 
              if (this.selectedMovieName.length) {
                payload["selectedMovieName"] = this.selectedMovieName.map(
                  (item) => {
                    return item.movie_name;
                  }
                );
              }
                  if (type === "filter2") {
                  payload["type"] = "filter2";
                }
                  if (this.selectedScreenName.length) {
                    payload["selectedScreenName"] = this.selectedScreenName.map(
                      (item) => {
                        return item.screen_name;
                      }
                    );
                  }
          let response = await NewReportService.getTicketReport(payload);
          this.ticketDataPaymentWise = []
            this.get3DAmountDataAsPerPaymentModes = []
            this.groupedDataForTicket = []
            this.groupedDataFor3DGlass = []
            this.groupedDataForPurgedTicket = []
            this.groupedDataForPurged3DGlass = []
            this.FreeTicketQueryData = []
            this.glass3DQueryForFreeData = []
          const { data } = response;
             if (type == "filter") {
                    this.allMovieNames = [...data.movieNamesData];
                  }
            else if (type === "filter2") {
                      this.allScreenNames = [...data.screenNamesData]; 
                    }
          else if (data.status && data.Records.length) {
            this.ticketDataPaymentWise = data.Records;
            this.get3DAmountDataAsPerPaymentModes = data.get3DAmountDataAsPerPaymentModes;
            this.groupedDataForTicket = data.groupedDataForTicket
            this.groupedDataFor3DGlass = data.groupedDataFor3DGlass
            this.groupedDataForPurgedTicket = data.groupedDataForPurgedTicket
            this.groupedDataForPurged3DGlass = data.groupedDataForPurged3DGlass
            this.FreeTicketQueryData = data.FreeTicketQueryData
            this.glass3DQueryForFreeData = data.glass3DQueryForFreeData
         
            this.grandTotal = data.grandTotal;
            if (data.pdfPath && isPdf == "Y") {
              window.open(data.pdfPath, "_blank");
            }
            if (data.excelPath && isExcel == "Y") {
              window.open(data.excelPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
        } catch (error) {
          console.log(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
    },
  };
</script>

<style scoped>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.rtl-table-scroll {
  direction: rtl;
}

.color-blue {
  background-color: #cccccc;
}
.text-bold {
  font-weight: bold;
}
.rtl-table {
  display: flex;
  flex-direction: row-reverse; /* Reverse column order */
}

.rtl-table td {
  text-align: right; /* Align text properly for Arabic */
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: blue !important;
  border-color: blue !important;
}
.reverse-order{
  direction: rtl;
}
.order{
  direction: ltr
}

/* Change radio button color */
.j-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: red !important; /* Change the radio background color */
  border-color: red !important; /* Change the border color */
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/ticketReportMif.vue